import React from 'react';
import { Box } from '@mui/material';

const RecipeImage = ({ 
  recipe, 
  imageError, 
  setImageError 
}) => {
  if (!recipe || !recipe.showImage) return null;
  
  return (
    <Box sx={{ 
      width: { xs: '100%', md: '300px' },
      height: { xs: '200px', md: '300px' },
      flexShrink: 0,
      borderRadius: { xs: 2, sm: 1 },
      overflow: 'hidden'
    }}>
      <Box
        component="img"
        src={recipe.image}
        alt={recipe.recipeNameDisplay || recipe.name}
        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        onError={() => setImageError(true)}
      />
    </Box>
  );
};

export default RecipeImage; 